import { useContext } from "react";
import { UserContext } from "../context/UserInformation";
import { auth } from "../services/firebase";
import { removeKeyFromObject } from "../types/utils/objectMutation";

export const useCurrentUserInfo = () => {
    const userContext = useContext(UserContext);

    if (!userContext) {
        throw new Error('Need UserContext');
    }

    return {
        isLoading: userContext.loading,
        user: userContext.user ?
            {
                ...removeKeyFromObject(userContext.user, 'firebaseUser'),
                id: userContext.user.firebaseUser?.uid || auth.currentUser?.uid || '',
            } : null,
    }
}